module.exports = __webpack_public_path__ + "static/media/bind-icon.4230912f.svg";